export enum ReportReasonPlace {
    ChatHistory = 'chat_history',
    Room = 'room',
    Story = 'story',
    PM = 'pm',
    HistoryTab = 'history_tab',
}
